import {isNullOrUndefined} from "../../../shared";
import {createSelector} from "reselect";
import { deburr } from "lodash";

const getEntities = (state) => state.myReportsReducers.data;
const getSearchTerm = (state) => state.myReportsReducers.searchTerm;

const getNotDeletedItems = createSelector([getEntities], (entities) => {
    return Object.values(entities).filter(
        (r) => isNullOrUndefined(r.deleted) || !r.deleted
    );
});

export const getEntitiesAsList = createSelector(
    [getNotDeletedItems, getSearchTerm],
    (entities, filterTerm) => {
        if (filterTerm) {
            return entities
                .filter((v) => {
                    return v.patente?.toLowerCase()?.includes(filterTerm.toLowerCase()) ||
                        v.emitDate?.toString()?.toLowerCase()?.includes(filterTerm.toLowerCase()) ||
                        (v.tipo_reporte === 'ANONYMOUS' ? 'anonimo' : 'completo').includes(deburr(filterTerm.toLowerCase()))
                })
                .sort((curr, next) => {
                    return next.createdAt - curr.createdAt;
                });
        }

        return entities.sort((curr, next) => {
            return next.createdAt - curr.createdAt;
        });
    }
);

export const getPendingReports = createSelector(
    [getNotDeletedItems],
    (entities) => {
        return (
            entities.filter((r) => r.progress >= 0 && r.progress < 100).length > 0
        );
    }
);

export const getCurrentUser = createSelector(
    (state) => state.authReducers.user,
    (profile) => profile
)
